export class Backoff {
  private n = 0;
  constructor(
    private baseMs = 500,
    private maxMs = 10000,
  ) {}
  next(): number {
    const exp = Math.min(this.maxMs, this.baseMs * Math.pow(2, this.n++));
    return exp / 2 + Math.random() * (exp / 2);
  }
  reset(): void {
    this.n = 0;
  }
}

export function wsUrl(path: string): string {
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${location.host}${path}`;
}

export function roomFromPath(): string {
  const parts = location.pathname.split("/").filter(Boolean);
  return parts[1] || "main";
}

/** Small safe localStorage wrapper (private mode / blocked storage must not break the page). */
export const store = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {}
  },
};

/** Screen Wake Lock, re-acquired when the page becomes visible again. */
export class WakeLock {
  private sentinel: any = null;
  private wanted = false;
  constructor() {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible" && this.wanted) this.acquire();
    });
  }
  async enable(): Promise<void> {
    this.wanted = true;
    await this.acquire();
  }
  async disable(): Promise<void> {
    this.wanted = false;
    const s = this.sentinel;
    this.sentinel = null;
    try {
      await s?.release();
    } catch {}
  }
  get supported(): boolean {
    return "wakeLock" in navigator;
  }
  private async acquire(): Promise<void> {
    if (!this.supported || this.sentinel || document.visibilityState !== "visible") return;
    try {
      this.sentinel = await (navigator as any).wakeLock.request("screen");
      this.sentinel.addEventListener("release", () => {
        this.sentinel = null;
      });
    } catch {
      // Denied (battery saver, iframe, etc.) – nothing else to do.
    }
  }
}
